module.exports = __webpack_public_path__ + "img/ic-phone-black.8a508158.svg";